'use client';

import { useEffect, useState } from 'react';

import { hämtaSenasteFel, prenumereraPåFel, type Felpost } from 'src/lib/fel/felbutik';
import { lyssnaPåRapportbegäran } from 'src/lib/fel/rapportdialog';
import { rapporteraKlientfel } from 'src/lib/fel/rapporteraKlientfel';

import { FelrapportDialog } from './FelrapportDialog';

/**
 * Monteras en gång i rotlayouten. Två uppgifter:
 *
 * 1. Fångar fel som React error boundaries missar — fel utanför rendering (event handlers,
 *    setTimeout) och avvisade promises — och skickar dem till felloggen.
 * 2. Äger rapportdialogen, så att den kan öppnas från en toast var som helst i appen.
 */
export function Felfångare() {
  const [öppen, setÖppen] = useState(false);
  const [fel, setFel] = useState<Felpost | null>(null);

  useEffect(() => prenumereraPåFel(setFel), []);

  useEffect(
    () =>
      lyssnaPåRapportbegäran(() => {
        setFel(hämtaSenasteFel());
        setÖppen(true);
      }),
    []
  );

  useEffect(() => {
    const vidFel = (händelse: ErrorEvent) => {
      if (händelse?.error instanceof Error) {
        rapporteraKlientfel(händelse.error);
      }
    };

    const vidAvvisadPromise = (händelse: PromiseRejectionEvent) => {
      const orsak = händelse?.reason;
      // Axios-fel har redan gått genom interceptorn och är lagrade på servern.
      if (orsak?.isAxiosError || orsak?.config) {
        return;
      }
      rapporteraKlientfel(orsak instanceof Error ? orsak : new Error(String(orsak)));
    };

    window.addEventListener('error', vidFel);
    window.addEventListener('unhandledrejection', vidAvvisadPromise);
    return () => {
      window.removeEventListener('error', vidFel);
      window.removeEventListener('unhandledrejection', vidAvvisadPromise);
    };
  }, []);

  return <FelrapportDialog öppen={öppen} fel={fel} vidStängning={() => setÖppen(false)} />;
}
